import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { IntegrationGuide } from './IntegrationGuide';
import { PIXEL_INTEGRATIONS } from './integrations';

const DEFAULT_PLATFORM = PIXEL_INTEGRATIONS[0].id;

/**
 * Installation guide page. Platforms are picked from the Pixel sub-nav "Installation guide"
 * group. The selected platform lives in `?platform=` (not a path segment) so the pathname
 * stays equal to ROUTES.PIXEL_INSTALLATION and PageLayout keeps the Pixel tab active.
 */
export const PixelInstallation = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('platform');
  const isKnown = PIXEL_INTEGRATIONS.some((integration) => integration.id === requested);
  const platform = isKnown && requested ? requested : DEFAULT_PLATFORM;

  useEffect(() => {
    if (!isKnown) {
      setSearchParams({ platform: DEFAULT_PLATFORM }, { replace: true });
    }
  }, [isKnown, setSearchParams]);

  return <IntegrationGuide integrationId={platform} />;
};
